import React from 'react';
import Constants from '../../containers/function/constants';

const ButtonsTop = (props) => {
  const { typeTab } = props;
  const { taskManagerTabs } = Constants;
  let title = '';

  switch (typeTab) {
    case taskManagerTabs.TAB_TASKS:
      title = props.language.tasks_manager.title.tasks_traceability;
      break;
    case taskManagerTabs.TAB_NOTIFICATIONS:
      title = props.language.tasks_manager.title.notifications_traceability;
      break;
  }

  return (
    <section className="module-filter top buttons-top" style={{...props.containerStyle}}>
      <div className="flex">
        <div className="buttons second-header">
        </div>
        <section className="module-title">
          <h2>{title}</h2>
        </section>
        <div className="excel-buttons">
          <div className="box-form">
            <ul className="buttom_menu">
              {
                (props.downloading) ? (
                  <li>
                    <i className="fas fa-spinner fa-spin"></i> {props.language.tasks_manager.excel.downloadingTitle}
                  </li>
                ) : (
                  <li>
                    {props.language.tasks_manager.excel.downloadExcel}
                    <ul>
                      <li>
                        <a data-close="ok" onClick={props.handleDownloadExcelSummary}>
                          {props.language.tasks_manager.excel.downloadSummaryExcel}
                        </a>
                      </li>
                      <li>
                        <a data-close="ok" onClick={props.handleDownloadExcelNoProcess}>
                          {props.language.tasks_manager.excel.downloadNoProcessExcel}
                        </a>
                      </li>
                    </ul>
                  </li>
                )
              }
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
};

export default ButtonsTop;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/buttonsTop.jsx